import styled from "styled-components";

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  background-color: transparent;
  /* border: 2px solid blue; */
  align-items: center;
  height: 100%;
`;

export default ButtonsWrapper;
